<template>
  <el-form :inline="true">
    <el-form-item v-for="(filterInfo,key) in filter" :key="key" :label="filterInfo.text">
      <el-input v-if="filterInfo.type=='string' || filterInfo.type=='int' ||filterInfo.type=='real'" v-model="returnValue[key]"
        :placeholder="filterInfo.placeholder" :style="`width:${filterInfo.width};`"></el-input>
      <el-date-picker v-else-if="filterInfo.type=='datetimerange'" v-model="returnValue[key]" type="datetimerange"
        range-separator="-" start-placeholder="起始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
        :style="`width:${filterInfo.width};`">
      </el-date-picker>
      <el-select v-else-if="filterInfo.type=='select'" v-model="returnValue[key]" filterable clearable :placeholder="filterInfo.placeholder"
        :style="`width:${filterInfo.width};`">
        <el-option v-for="(option,idx) in filterInfo.options" :key="idx" :label="option" :value="option">
        </el-option>
      </el-select>
      <el-select v-else-if="filterInfo.type=='select2'" v-model="returnValue[key]" filterable clearable :placeholder="filterInfo.placeholder"
        :style="`width:${filterInfo.width};`">
        <el-option-group v-for="(devices,district) in filterInfo.options" :key="district" :label="district">
          <el-option v-for="(item,idx) in devices" :key="idx" :label="item" :value="item">
          </el-option>
        </el-option-group>
      </el-select>
    </el-form-item>
    <el-form-item style="margin-left:80px;">
      <el-button-group>
        <el-button type="primary" icon="el-icon-delete" @click="handleClear" style="padding-left:5px;padding-right:10px;">清空</el-button>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch" style="padding-left:5px;padding-right:10px;">搜索</el-button>
      </el-button-group>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    data() {
      return {
        returnValue: {}
      };
    },
    mounted() {},
    watch: {},
    props: ["filter"],
    methods: {
      handleClear() {
        for (let key in this.returnValue) {
          this.returnValue[key] = null;
        }
        this.$emit("handleSearch", this.returnValue);
      },
      handleSearch() {
        // value检验
        let invalidFields = [];
        for (let key in this.returnValue) {
          let value = this.returnValue[key];
          let type = this.filter[key].type;
          if (value) {
            if (type == "int" || type == "real" || type == "string") {
              value = value.trim();
              this.returnValue[key] = value
            }
            if (value == "") continue;
            // 主要检验整数和实数
            if (type == "int") {
              const temp = Number(this.returnValue[key]);
              if (isNaN(temp)) {
                this.returnValue[key] = null;
                invalidFields.push(this.filter[key].text);
              } else {
                this.returnValue[key] = parseInt(temp).toString();
              }
            } else if (type == "real") {
              const temp = Number(this.returnValue[key]);
              if (isNaN(temp)) {
                this.returnValue[key] = null;
                invalidFields.push(this.filter[key].text);
              }
            }
          }
        }
        if (invalidFields.length > 0) {
          this.$message({
            duration: 2000,
            showClose: true,
            message: `${invalidFields.join('、')} 的格式不正确`,
            type: "error"
          });
        } else {
          this.$emit("handleSearch", this.returnValue);
        }
      }
    }
  };

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Input/SearchFilter.vue